<template>
  <div class="popLoginBg">
    <div class="popLogin">
      <div class="popLogo">
        <img
          src="../../assets/images/logo.png"
          alt=""
          class="logo"
        />
        <span class="name">欢迎登录</span>
      </div>
      <div class="pageImg">
        <div class="lcImg"></div>
        <div class="cnt">
          
          <a-tabs
            :activeKey="activityKey"
            :animated="false"
            @change="handleTabChange"
          >
            <a-tab-pane key="2" tab="密码登录">
              <div class="message">
                <div v-if="message">
                  <img src="../../assets/images/icon-notice.png" alt="" />
                  <span>{{ message }}</span>
                </div>
              </div>
              <loginInput
                :iParam="userSet"
                @resetVal="reset(userSet)"
                @trimAll="trimAll"
              >
                <img src="../../assets/images/icon-account.png" alt="" />
              </loginInput>
              <loginInput :iParam="pwdSet" @resetVal="reset(pwdSet)">
                <img src="../../assets/images/icon-password.png" alt="" />
              </loginInput>
              <div class="cntIdentifyCode">
                <div class="identifyCodeName">
                  <input
                    name="identifyCode"
                    @keyup.enter="login"
                    placeholder="请输入验证码"
                    type="text"
                    v-model="identifycode"
                    class="identifyCodeNameInput"
                  />
                </div>
                <div class="pwdImg" @click="getCodePic">
                  <img :src="picCodeSet.src" alt="" class="pwdImg" />
                </div>
              </div>
              <div class="cntLogiButton">
                <!-- <a
                  href="javascript:void(0);"
                  class="button"
                  @click="login"
                  v-show="!loginLoading"
                  >立即登录</a
                >
                <a
                  href="javascript:void(0);"
                  class="button loginLoading"
                  v-show="loginLoading"
                  >
                  立即登录</a
                > -->
                <Button :loading="loginLoading" type="primary" size="large"  @click="login">立即登录</Button>
              </div>
            </a-tab-pane>
          </a-tabs>
          <div class="cntfr">
            <!-- <a href="javascript:void(0);" class="button" @click="register"
              >免费注册</a
            > -->
            <a></a>
            <a
              v-if="showEditPwd"
              href="javascript:void(0);"
              class="button"
              @click="changePwd"
              >修改密码</a
            >
            <a href="javascript:void(0);" class="button" @click="forget"
              >忘记密码？</a
            >
          </div>
        </div>
      </div>
      <Modal
        :visible="showBindnumber"
        @cancel="cancelBind"
        class="loginmodel"
        :closable="false"
        :maskClosable="false"
      >
        <div class="modelnotice">
          <img src="../../assets/images/logo.png" alt="" />
          <div>
            <p>登录成功！</p>
            <p>因系统升级，需要您绑定手机，方可进入商家工作台</p>
               
          </div>
        </div>
        <template slot="footer">
          <Button @click="handleBind" type="primary">绑定手机</Button>
        </template>
      </Modal>
      <Modal
        :visible="showOffsiteLogin"
        @cancel="cancelOffsite"
        class="loginmodel"
        :maskClosable="false"
        title="提示"
        @ok="handleOk"
      >
        <div class="offsiteLogin">
          <div>
            <h1 class="offsiteLoginTitle">登录校验</h1>
            <p class="offseteLoginContent">
              为了保护您的账号资金安全，此次登录需完成手机验证码校验。
            </p>
            <div class="verifyMobil">
              <span
                >手机号：{{
                  this.phone.substring(0, 4 - 1) +
                  "****" +
                  this.phone.substring(6 + 1)
                }}</span
              >
              <p>
                验证码：
                <a-input
                  v-model="remoteLandingCode"
                  placeholder="请输入验证码"
                />
                <Button v-if="yzmTime > 0" disabled class="getCode"
                  >{{ yzmTime }}秒后重发</Button
                >
                <Button @click="getVerificationCode" v-else class="getCode">{{
                  codeText
                }}</Button>
              </p>
                 
            </div>
          </div>
        </div>
        <template slot="footer">
          <Button @click="handleOk" type="primary">完成</Button>
          <Button @click="cancelOffsite" type="primary">取消</Button>
        </template>
      </Modal>
      <div class="popFooter" v-if="popFooter">
        <!-- <div class="popFooterTitle">
          <a
            v-for="(item, index) in popFooter.nav"
            :href="item.link"
            target="_blank"
            :key="index"
            >{{ item.title }}</a
          >
        </div> -->
        <div class="popFooterTag">
          <p v-for="(item, index) in popFooter.tag" :key="index">
            <a
              :href="item.link"
              target="_blank"
              :key="index"
              v-if="item.link"
              style="color: #8a93a7"
              >{{ item.title }}</a
            >
            <span v-else>{{ item.title }}</span>
          </p>
        </div>
      </div>
    </div>
    <iframe name='middle-iframe-by-pop' id="middle-iframe-by-pop"  frameborder="0" :src="middleUrlByPop" :style="{ height: 0, width: 0 }"></iframe>
    <iframe name='middle-iframe-by-self' id="middle-iframe-by-self"  frameborder="0" :src="middleUrlBySelf" :style="{ height: 0, width: 0 }"></iframe>
  
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import loginInput from "./components/loginInput";
import QrcodeLogin from "./components/qrcodeLogin";
import { Base64 } from "js-base64";
import api from "@utils/api";
import { http, cookies, util, localStore, $http } from "@utils";
import { isLeYou } from '@/shared/utils/constant'
import queryString from "query-string";
import cookie from "js-cookie";
import appConst from "@utils/constant";
import { Modal, Button, Tabs, Icon } from "ant-design-vue";
import { setPublicKey } from '../../shared/utils';
const maxTimes = 200;
const START = "start";
const PAUSE = "pause";
const STOP = "stop";

export default {
  name: "login",
  data() {
    return {
      // appCode: 'sso',
      // appServiceCode: '102',
      yzmTime: 0,
      codeText: "短信验证码",
      userSet: {
        value: "",
        placeholder: "手机号/B账号/w账号",
        type: "username",
        // len: 11,
      },
      phone: "",
      pwdSet: {
        value: "",
        placeholder: "请输入密码",
        type: "password",
      },
      picCodeSet: {
        src: "",
      },
      identifycode: "",
      codeNumber: {
        identity: "",
        appCode: "",
        appServiceCode: "",
      },
      verifyCode: "",

      message: "",
      popFooter: {},
      showBindnumber: false,
      showOffsiteLogin: false,
      remoteLandingCode: "", //异常登录验证码
      partnerDomain: "",
      loginLoading: false, //登录状态  true:登陆中,false:未在登陆中
      showEditPwd: false,
      activityKey: "2",
      showCodeDown: false,
      qrCodeStatus: "",
      qrCodeToken: "",
      qrCodeLoading: false,
      qrCodeRefreshTimes: maxTimes,
      funcStatus: STOP,

      middleUrlByPop: 'https://shop.leyou.com.cn/middle',
      middleUrlBySelf: 'https://srm.leyou.com.cn/middle/'
    };
  },
  async mounted() {
    util.$tracker(148, "288918", 10000);
    if (isLeYou) {
      util.setCookies('_platform_id', 10002, 24, ".leyou.com");
    }
    this.getCodePic();
    this.getPopFooter();
    // this.refreshQrcode();
  },
  beforeDestroy() {
    this.qrCodeRefreshTimes = -1;
  },
  watch: {
    "userSet.value": {
      handler(newV, oldV) {
        this.message = "";
        if (newV.substr(0, 1) !== "w") {
          if (newV.length === 11) {
            this.confirmUser();
          }
        }
      },
      deep: true,
    },
    showCodeDown: {
      async handler(newName, oldName) {
        if (newName) {
          const res = await this.sendPhoneMsg(this.phone);
          if (res.code * 1 === 1) {
            this.yzmTime = 60;
            this.codeText = "再次获取";
            this.$message.info(
              "验证码已发送至手机，5分钟内输入有效，请勿泄漏！"
            );
            const t = () => {
              setTimeout(() => {
                this.yzmTime = this.yzmTime - 1;
                if (this.yzmTime > 0) {
                  t();
                }
              }, 1000);
            };
            t();
            setTimeout(() => {
              this.showCodeDown = false;
            }, this.yzmTime * 1000);
          } else {
            this.codeText = "再次获取";
            this.showCodeDown = false;
            this.$message.error(res.msg || "系统异常");
          }
        } else {
          console.log("no work");
        }
      },
      immediate: true,
    },
  },
  computed: {
    isPhoneRight() {
      if (this.checkPhone(this.userSet.value)) {
        // 如果输入手机号，校验手机号是否存在， 就return true
        this.getCodePic();
        return true;
      } else {
        this.message = "";
        return false;
      }
    },
  },
  methods: {
    ...mapMutations(["setFooterInfo"]),
    async getPopFooter() {
      const response = await http.get(
        `${api.cmsHost}/publish/976/leyou-foot.json`
      );
      if (response && response.data) {
        this.popFooter = response.data;
        this.setFooterInfo(response.data);
        let { jumpLinks = {} } = response.data;
        this.partnerDomain = jumpLinks.partner.domain || api.partnerHost;
        if (Object.keys(jumpLinks).length > 0) {
          localStore.setItem("jumpLinks", jumpLinks);
        } else {
          localStore.removeItem("jumpLinks");
        }
      } else {
        localStore.removeItem("jumpLinks");
      }
    },
    reset(obj) {
      obj.value = "";
    },
    trimAll(obj) {
      this.userSet.value = obj;
    },
    getServiceType(v) {
      const _d = `APPSERVICECODE_${v}`;
      return appConst[_d];
    },
    // 发送短信验证码接口，验证码在后台查看
    async sendPhoneMsg(value) {
      // const serviceCode = `${appConst.APPSERVICECODE}`;
      // templateCode: 'ec2e53f454064cefad407a566224fa3f',   测试短信模板
      const serviceCode = this.getServiceType("LOGIN");
      const _api = `${api.mainHost}/portal-api/user/sendPhoneMsg.do`;
      const param = JSON.stringify({
        identity: `${value}`,
        serviceCode,
        templateType: "1",
        sms: {
          phone: `${value}`,
          message: "",
          params: "",
        },
      });
      const res = await http.post(_api, queryString.stringify({ param }), {
        headers: {
          "content-Type": "application/x-www-form-urlencoded",
        },
      });
      return res;
    },
    // 验证手机号正确
    checkPhone(val) {
      const phoneReg = /^1\d{10}$/;
      return phoneReg.test(val);
    },
    // 获取图形验证码
    async getCodePic() {
      const uuidV4 = require("uuid/v4");
      this.codeNumber.identity = Base64.encode(
        `${this.userSet.value}_${uuidV4()}`
      );
      this.codeNumber.appCode = Base64.encode(`${appConst.APPCODE}`);
      this.codeNumber.appServiceCode = Base64.encode(`100`);
      const query = queryString.stringify(this.codeNumber);
      this.picCodeSet.src = `${api.verifycodeHost}/ucode-web/ucode/getNumber.do?${query}`;
    },
    // 确认用户手机号是否被注册过
    async confirmUser() {
      if (this.userSet.value === "") {
        this.message = "手机号不能为空";
        return false;
      }
      if (!this.checkPhone(this.userSet.value)) {
        this.message = "请输入正确的手机号";
        return false;
      }
      const _api = `${api.mainHost}/portal-api/account/validPhone.do`;
      const res = await $http.get(`${_api}?phone=${this.userSet.value}`);
      if (res.code === "1") {
        this.message = res.data === true ? "" : "账号不存在或被禁用，请确认"; // true 已注册， false 未注册
      } else {
        this.$message.error(res.msg || "系统异常");
      }
      return res.data;
    },
    // 点击登录调接口前校验
    async login() {
      if (this.loginLoading) return;
      if (this.userSet.value === "") {
        this.message = "用户名不能为空";
        return false;
      }
      if (this.pwdSet.value === "") {
        this.message = "密码不能为空";
        return false;
      }
      if (this.identifycode === "") {
        this.message = "验证码不能为空";
        return false;
      }
      
      this.message = "";
      this.loginLoading = true;
  
      // '三个都验证结束后，调用登录接口'
      this.userlogin(this.userSet.value, this.pwdSet.value, this.identifycode);
    },
    // 发送验证码
    getVerificationCode() {
      this.showCodeDown = true;
      return true;
    },
    jumpTolink(name) {
      if (name === "home") {
        window.location.href = "//shop.leyou.com/platform/ly";
        // util.jumptoNcHomepage();
      } else {
        this.$router.push({
          name,
        });
      }
    },
    setCookieItem(v) {
      const {
        buzzCode,
        buzzId,
        buzzType,
        platformNum,
        id,
        parentBuzzId,
        userId,
      } = v;
      let _cookie = {
        ...v.cookies,
        buzzCode,
        buzzId,
        buzzType,
        platformNum,
        id,
        parentBuzzId,
        userId,
      };
      // 2022-04-24 安全修复，以下cookie服务端设置为http-only
      // let omitItems = ['siteToken']
      for (let item in _cookie) {
        // if (!omitItems.includes(item)) {
          // 接口开关控制，前端不做过滤，如果接口开关打开，则siteToken以服务端设置为准，前端设置不生效，否则以前端设置生效
          util.setCookies(item, _cookie[item] || "", 24, ".leyou.com");
        // }
      }
    },

// 获取头部信息
 getHeaderParams(data, transactionType, app_id = 10000024) {
  let params = {};
  let header = {};
  // 获取时间
  let time_stamp = new Date().getTime();
  let number = Math.floor(Math.random() * (9999 - 1000) + 1000);
  console.log(number);
  header.message_id = time_stamp + number.toString();
  header.time_stamp = time_stamp.toString();
  header.transaction_type = transactionType;
  header.app_id = 10000031; // 转换10000031
  header.token =
    localStorage.getItem('antd-pro-token') == null
      ? 'fb35a49bb6df7ebdf1e12a42b88010a6'
      : JSON.parse(localStorage.getItem('antd-pro-token')).token;
  params.header = header;
  if (null != data && Object.keys(data).length && data != undefined) {
    params.body = data;
  } else {
    params.body = {};
  }
  return params;
},

    // 登录接口
    async userlogin(userName, password, verifyCode, status) {
      const cookieDomain = location.host.replace(
        /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}\./,
        "."
      );
      // const _api = `${api.mainHost}/portal-api/user/login.do`
      const _api = `${api.mainHost}/portal-api/user/loginNew.do`;
      let loginQuery = "";
      if (status) {
        if (!verifyCode) {
          this.$message.error("请输入短信验证码");
          return;
        }
        loginQuery = queryString.stringify({
          userName,
          password,
          passType: 0,
          appServiceCode: "login",
          verifyCodeType: "2",
          verifyCode,
          vuuid: this.codeNumber.identity,
          appCode: this.codeNumber.appCode,
        });
      } else {
        loginQuery = queryString.stringify({
          userName,
          password,
          passType: 0,
          verifyCode,
          vuuid: this.codeNumber.identity,
          appCode: this.codeNumber.appCode,
        });
      }

      const res = await $http.get(`${_api}?${loginQuery}`);
      this.loginLoading = false;
      const isWaccount = userName.substr(0, 1).toLocaleLowerCase() === "w"; // 修改兼容W和w账号
      if (res && res.code === "1") {
        const _d = res.data;
        const timestamps = res.timestamps;
        const _link = `${this.$route.query.link}`;
        const _linkName = this.$route.query.linkName || "home";
        this.setCookieItem(_d);
        // 乐友登陆态操作
        const leyouToken = JSON.stringify({ token: _d.leyouToken, time: timestamps, expire: 10800})
        // 乐友获取useInfo
        const leyouUserInfo = _d.leyouUserInfo
        const userInfo = JSON.stringify(leyouUserInfo || '')

        const localStorageArr = [{
          type: 'setLocalStorage',
          key: 'antd-pro-userInfo',
          data: userInfo
        }, {
          type: 'setLocalStorage',
          key: 'antd-pro-token',
          data: leyouToken
        }, {
          type: 'setLocalStorage',
          key: 'antd-pro-authority',
          data: ['admin']
        }]
        if (_d.leyouAppId === '10000031') { // pop
          localStorageArr.push(...[
          {
            type: 'setLocalStorage',
            key: 'antd-pro-status',
            data: 1
          }, {
            type: 'setLocalStorage',
            key: 'antd-pro-stock', // 商品库存不足
            data: 3
          }, {
            type: 'setLocalStorage',
            key: 'userflagtype',
            data: (leyouUserInfo || {}).leyou_user_flag || ''
          }])
        }

        // 乐友中间页写token
        const iframeWindowByPop = (document.getElementById('middle-iframe-by-pop') && document.getElementById('middle-iframe-by-pop').contentWindow)
        const iframeWindowBySelf = (document.getElementById('middle-iframe-by-self') && document.getElementById('middle-iframe-by-self').contentWindow)
        if (!iframeWindowByPop || !iframeWindowBySelf) return // todo 报错重试
        localStorageArr.forEach(item => {
          localStorage.setItem(item.key, item.data);
          iframeWindowByPop.postMessage(item, '*')
          iframeWindowBySelf.postMessage(item, '*')
        })
        if (isWaccount) {
          if (_d.phone === "") {
            // w账号未绑定 显示model
            cookies.set("buzzName", Base64.encode(_d.buzzName || ""));
            this.showBindnumber = true;
          } else {
            // w账号已绑定 没有跳转到pop门户首页  有link就进行跳转
            this.jumpToRlink(_link, _linkName);
          }
        } else if (1 * res.data.buzzType === 7) {
          // buzzType = 7 代表协同平台  没有link跳转协同平台  有link就进行跳转
          if (_link !== "undefined" && _link.length > 0) {
            window.location.href = _link;
          } else {
            const { jumpLinks } = this.popFooter;
            const { partner } = jumpLinks;
            if (partner && partner.newPlatform && partner.platformUrl) {
              //新平台打开，就跳新平台
              window.location.href = partner.platformUrl;
            } else {
              window.location.href = `${this.partnerDomain}/view/new-main.jsp`; // 协同平台测试环境
            }
          }
        } else {
          // 手机号登录  有link就进行跳转  没有就跳转到pop门户首页
          this.jumpToRlink(_link, _linkName);
        }
      } else if (res && res.code === "30000001") {
        this.phone = res.data.securityLoginMobile;
        this.showOffsiteLogin = true;
      } else {
        if (res.code === "2006013") {
          this.$message.error(res.msg);
        } else {
          this.getCodePic();
          this.message = res.msg;
          if (res && ["2001603", "2002012", "2001609"].includes(res.code)) {
            this.showEditPwd = true;
          } else {
            this.showEditPwd = false;
          }
        }
      }
    },
    jumpToRlink(_link, _linkName = "home") {
      if (_link !== "undefined" && _link.length > 0) {
        const { jumpLinks = {} } = this.popFooter;
        const { seller, partner, yuer, czj } = jumpLinks || {};
        const buzzType = cookie.get("buzzType");
        let platform = {};
        if (buzzType * 1 === 1 || buzzType * 1 === 2) {
          platform = seller;
        } else if (
          buzzType * 1 === 3 ||
          buzzType * 1 === 4 ||
          buzzType * 1 === 7
        ) {
          platform = partner;
        } else if (buzzType * 1 === 5) {
          platform = yuer;
        } else if (buzzType * 1 === 6) {
          platform = czj;
        }
        if (
          platform &&
          !platform.newPlatform &&
          _link.indexOf(platform.platformUrl) > -1
        ) {
          //新平台没打开，就不给往新平台跳
          window.location.href = "//shop.leyou.com/platform/ly";
        } else {
          window.location.href = _link;
        }
      } else {
        this.jumpTolink(_linkName);
      }
    },
    cancelBind() {
      this.showBindnumber = false;
    },
    cancelOffsite() {
      this.showOffsiteLogin = false;
      this.remoteLandingCode = "";
    },
    handleBind() {
      this.showBindnumber = false;
      this.jumpTolink("bindMobile");
    },
    // 异地登录
    async handleOk() {
      await this.userlogin(
        this.userSet.value,
        this.pwdSet.value,
        this.remoteLandingCode,
        "different"
      );
    },
    forget() {
      this.jumpTolink("leyouforget");
    },
    register() {
      this.jumpTolink("register");
    },
    changePwd() {

      // this.jumpTolink("leyousafe-change-password")
      this.$router.push({
        name: "leyou-auth-change-password",
        query: { account: this.userSet.value },
      });
    },
    handleTabChange(v) {
      this.activityKey = v;
      if (v === "1" && this.funcStatus === PAUSE) {
        this.qrCodeCheckAndLogin();
      }
    },
    gotoScanLogin() {
      this.activityKey = "1";
      if (this.funcStatus === PAUSE) {
        this.qrCodeCheckAndLogin();
      }
    },
    async refreshQrcode() {
      // await this.generateQrCodeToken();
      this.qrCodeCheckAndLogin();
    },
    async generateQrCodeToken() {
      try {
        this.qrCodeLoading = true;
        const res = await http.get(
          `${api.mainHost}/portal-api/qrCodeLogin/generateQrCodeToken.do`
        );
        if (res && +res.code === 1) {
          this.qrCodeRefreshTimes = maxTimes;
          this.qrCodeToken = res.data;
        } else {
          this.qrCodeToken = "error";
        }
      } catch (e) {
        this.qrCodeToken = "error";
      } finally {
        this.qrCodeLoading = false;
      }
    },
    async qrCodeCheckAndLogin() {
      // 函数执行状态 start 开始； pause 暂停 stop 结束
      if (this.funcStatus === START) {
        return;
      }
      this.funcStatus = START;
      if (this.qrCodeRefreshTimes < 0) {
        this.qrCodeStatus = 211020001;
        this.funcStatus = STOP;
        return;
      }
      if (this.activityKey !== "1") {
        this.funcStatus = PAUSE;
        return;
      }
      if (!this.qrCodeToken || this.qrCodeToken === "error") {
        this.funcStatus = STOP;
        return;
      }
      this.qrCodeRefreshTimes -= 1;
      try {
        const res = await $http.get(
          `${api.mainHost}/portal-api/qrCodeLogin/qrCodeCheckAndLogin.do?qrCodeToken=${this.qrCodeToken}`
        );
        if (res) {
          if (+res.code === 1) {
            this.funcStatus = STOP;
            // 登录成功
            const _d = res.data;
            const _link = `${this.$route.query.link}`;
            const _linkName = this.$route.query.linkName || "home";
            this.setCookieItem(_d);
            this.jumpToRlink(_link, _linkName);
          } else {
            // 二维码状态值
            // 211020001  二维码已过期
            // 211020002  二维码未扫描
            // 211020003  二维码已扫描
            // 211020004  取消登录
            // 211020005  二维码不合法
            // 211020006  登录失败, 请重新扫码二维码
            this.qrCodeStatus = res.code;
            if ([211020002, 211020003, 211020004].includes(+res.code)) {
              await util.sleep(2);
              this.funcStatus = PAUSE;
              this.qrCodeCheckAndLogin();
            } else if ([211020001, 211020005].includes(+res.code)) {
              this.funcStatus = STOP;
              return;
            } else {
              await this.generateQrCodeToken();
              this.funcStatus = PAUSE;
              this.qrCodeCheckAndLogin();
            }
          }
        } else {
          this.funcStatus = STOP;
        }
      } catch (e) {
        this.funcStatus = STOP;
      }
    },
  },
  components: {
    loginInput,
    Modal,
    Button,
    [QrcodeLogin.name]: QrcodeLogin,
    [Tabs.name]: Tabs,
    [Tabs.TabPane.name]: Tabs.TabPane,
    Icon
},
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  height: 100%;
}

.loginmodel .ant-modal-footer {
  text-align: center;
}

.cnt {
  position: relative;
  .ant-tabs-bar {
    border-bottom: 0;
  }
  .ant-tabs-nav .ant-tabs-tab {
    padding: 6px 0;
    line-height: 22px;
    font-size: 16px;
    font-weight: 500;
  }
}

.qrcode-login-tip {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: flex-start;
  .qrcode-img {
    cursor: pointer;
  }
  label {
    font-weight: 400;
    text-align: center;
    color: #1c7ae5;
    line-height: 18px;
    position: absolute;
    top: 3px;
    left: 14px;
  }
}
</style>

<style lang="scss" scoped>
.modelnotice {
  display: flex;
  img {
    width: 120px;
    height: 42px; // 图片变形修改
    margin-right: 10px;
  }
}

.popLoginBg {
  width: 100vw;
  height: 100vh;
  min-width: 1200px;
  background: url(../../assets/images/login-bg.png) no-repeat;
  background-size: cover;
  line-height: 1;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // position: fixed;
  // top: 0;
  // left: 0;

  .popLogin {
    padding-top: 30px;
    width: 100%;
    height: 640px;
    line-height: 1;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -56%);

    .popLogo {
      height: 48px !important;
      margin: 20px;
      display: inline-flex;

      .logo {
        width: 144px;
        height: 48px;
        margin: 8px 10px 0 200px;
        cursor: pointer;
      }

      .name {
        // font-weight: bold;
        font-size: 20px;
        color: #333333;
        padding: 23px 0 0 0px;
      }
    }

    .pageImg {
      display: flex;
      // background-color: linear-gradient(to right,#27088e, #28007f);
      background-image: url(../../assets/images/ly-bg.jpg);
      // background-image: url(https://hzwimspic-1251601690.image.myqcloud.com/cc2b93e0-aed0-11ea-be35-1b7c6890af60_size_16001x4001);
      background-repeat: repeat-x;
      background-position: center center;
      background-size: auto 100%;
      // background-size: 50%
      height: 480px;
      min-width: 1200px;

      .lcImg {
        width: 50%;
        height: 480px;
      }
      .cnt {
        width: 400px;
        height: 420px;
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        margin: 30px 50px 0 140px;

        .cntIdentifyCode {
          z-index: 19;
          position: relative;
          height: 44px;
          margin-bottom: 20px;
          border-radius: 4px;
          background: #fff;
          font-size: 14px;
          line-height: 44px;
          display: flex;
          justify-content: space-between;

          .identifyCodeName {
            width: 230px;
            height: 44px;
            border: 1px solid #cccccc;
            border-radius: 4px;
            background: #fff;
            font-size: 14px;
            line-height: 44px;

            &Input {
              width: 180px;
              height: 36px;
              border: 0;
              outline: none;
              font-size: 14px;
              padding-left: 10px;
            }
          }

          .pwdImg {
            width: 94px;
            height: 44px;
            cursor: pointer;
            line-height: 44px;
          }

          img {
            width: 94px;
            height: 44px;
            cursor: pointer;
            line-height: 44px;
          }
        }

        .cntLogiButton {
          .ant-btn {
            width: 340px;
            height: 44px;
            cursor: pointer;
            text-align: center;
          }
          .button {
            display: block;
            width: 340px;
            height: 44px;
            cursor: pointer;
            text-align: center;
            color: #fff;
            font-size: 16px;
            line-height: 44px;
            background: #1c7ae5;
            border-radius: 4px;
            text-decoration: none;
            &.loginLoading {
              background: rgba(28, 122, 229, 0.8);
            }
          }
        }

        .cntfr {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;

          a {
            height: 44px;
            cursor: pointer;
            text-align: center;
            color: #666;
            font-size: 14px;
            line-height: 44px;
            border-radius: 4px;
            text-decoration: none;
          }
        }
      }
    }

    @media screen and (min-width: 1980px) {
      .pageImg {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% auto;
      }
    }
  }

  .message {
    font-size: 12px;
    color: #666666;
    line-height: 16px;
    min-height: 16px;
    margin-bottom: 8px;

    img {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }

  .popFooter {
    margin: 40px;
    font-size: 14px;
    color: #666666;
    text-align: center;

    .popFooterTitle {
      margin-bottom: 16px;

      a {
        color: #666666;
        font-size: 14px;
        text-decoration: none;

        &::after {
          content: "";
          display: inline-block;
          width: 1px;
          height: 12px;
          margin: 0 10px;
          background: #666;
        }

        &:last-child::after {
          background: rgba(0, 0, 0, 0);
        }

        &:hover {
          color: #999;
        }
      }
    }

    .popFooterTag {
      display: flex;
      justify-content: center;
      margin-top: 100px;
      p {
        position: relative;
        font-size: 14px;
        color: #8a93a7;
        padding: 0 10px;
        padding-right: 14px;
        &:after {
          content: "/";
          color: #8a93a7;
          position: absolute;
          right: -5px;
          height: 18px;
          top: 50%;
          font-size: 11px;
          transform: translateY(-30%);
          width: 10px;
        }
        &:last-child:after {
          content: "";
        }
      }
    }
  }
}

@media screen and (min-height: 688px) {
  .popLoginBg {
    position: fixed;
    top: 0;
    left: 0;

    .popLogin {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
    }
  }
}
.offsiteLoginTitle {
  width: 100%;
  text-align: center;
  font-size: 20px;
}
.offseteLoginContent {
  margin-top: 10px;
  font-size: 15px;
}
.verifyMobil span {
  margin: 15px 0;
  display: block;
}
.verifyMobil p input {
  width: 150px;
}
.verifyMobil p .getCode {
  cursor: pointer;
  color: #fff;
  background: #1c7ae5;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 10px;
  line-height: 35px;
  height: 35px;
  margin-left: 10px;
}
</style>

